import React from 'react'
import { Outlet } from 'react-router-dom'

function MainInstaller() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainInstaller
